import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { MotionReduce } from "./MotionReduce";
export var Motion = /*#__PURE__*/function () {
  function Motion() {
    _classCallCheck(this, Motion);
    this.disable = false;
    this.reduce = new MotionReduce();
  }
  _createClass(Motion, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      if (data.disable !== undefined) {
        this.disable = data.disable;
      }
      this.reduce.load(data.reduce);
    }
  }]);
  return Motion;
}();